module.exports = __webpack_public_path__ + "media/images/icon-filter-product-6360e5f518c4a7747406544d9b898efd.png";